import { capFirst } from "#js/components/utils"
import { LitElement, html, css } from "lit"
import { msg, updateWhenLocaleChanges } from "@lit/localize"
import { setLocale } from "#js/components/lit-i18n"

export class FileInput extends LitElement {
  static formAssociated = true

  static properties = {
    inputID: { type: String },
    name: { type: String },
    accept: { type: String },
    selectedFileName: { type: String, state: true, reflect: false },
    labelText: { type: String },
  }

  static styles = css`
    .hidden-input {
      opacity: 0;
      position: absolute;
      width: 1px;
    }
  `

  constructor() {
    super()
    setLocale(globalThis.language)
    updateWhenLocaleChanges(this)
    this._internals = this.attachInternals()
  }

  render() {
    return html`
      <link rel="stylesheet" href="${globalThis.styleFilePath}" />
      <div class="row row--gap" style="align-items: center">
        <label
          for="${this.inputID}"
          class="button button--outlined"
          style="width: min-content"
        >
          ${this.labelText}
        </label>
        <input
          type="file"
          name="${this.name}"
          id="${this.inputID}"
          class="hidden-input"
          @change="${this.displayFileName}"
          accept="${this.accept}"
        />
        <span>${this.getFileName()}</span>
      </div>
    `
  }

  getFileName() {
    if (this.selectedFileName) {
      return this.selectedFileName
    }
    return capFirst(msg("no file chosen"))
  }

  displayFileName(event) {
    const fileInput = event.target
    if (fileInput.files?.length > 0) {
      this.selectedFileName = fileInput.files[0].name
      this._internals.setFormValue(fileInput.files[0])
    } else {
      this.selectedFileName = null
      this._internals.setFormValue(null)
    }
  }
}

globalThis.customElements.define("file-input", FileInput)
